import React from "react";
import { Route, Routes } from "react-router-dom";
import { PageShell } from "./components/layout";
import SEO from "./components/SEO";
import { routes } from "./routes";

function App() {
  return (
    <Routes>
      {routes.map((route) => {
        const content = (
          <>
            <SEO path={route.path} {...route.metadata} />
            {route.element}
          </>
        );

        return (
          <Route
            key={route.path}
            path={route.path}
            element={route.standalone ? content : <PageShell>{content}</PageShell>}
          />
        );
      })}
    </Routes>
  );
}

export default App;
